module.exports = __webpack_public_path__ + "img/car2.745ca575.png";